/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-08 13:49:18
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title30 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P30 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      tableColumns: [],
      tableList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          // width: index > 0 ? 80: 'auto',
          height: 22,
          fontSize: 12,
          textAlign: 'center',
          fontWeight: 'normal',
          color: '#000',
          background: '#fff',
          border,
        },
        colStyle: (val, r, i) => {
          return {
            height: 22,
            fontSize: 12,
            textAlign: i > 0 ? 'center' : 'right',
            fontWeight: 'normal',
            background: '#fff',
            border,
          }
        },
        render: (val, record, i, index) => {
          if (index > 0) {
            return <span className={s.block} style={{ background: val }} />
          }
          return val;
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, chartColorList, tableColumns, tableList } = this.state;
    return (
      <Stage>
        <div className={s.contentBox}>
          <Title30 pageNumber="2.7">
            传播可见度分析
          </Title30>
          <div contentEditable className={s.subTitle}>
            传播可见度为9.33%，高于上半财年；顶流内容为45条，多与索尼回应手机业务退出中国传闻相关
          </div>
          <div className={s.content}>
            <ul className={s.desContent}>
              <li contentEditable>
                理想情况下，品牌的有效、高效和顶流内容占比应尽可能多，代表品牌传播的内容得到用户广泛关注与积极互动，否则为无效传播
              </li>
              <li contentEditable>
                索尼的传播可见度为：<span className={s.emphasis}>9.33%</span>，（高于上半财年<span className={s.emphasis}>8.91%</span>）。无效/低效内容条数是有效内容（包含顶流/高效内容）的<span className={s.emphasis}>9.72倍</span>。
              </li>
              <li contentEditable>
                其中，顶流内容有<span className={s.emphasis}>45条</span>（略低于上半财年<span className={s.emphasis}>46条</span>），微信号平台贡献条数最多，为<span className={s.emphasis}>19条</span>，其次为新浪财经头条号（<span className={s.emphasis}>13条</span>），新浪看点（<span className={s.emphasis}>8条</span>），内容多与索尼回应手机业务退出中国传闻相关。

              </li>
              <li contentEditable>
                无效内容/低效内容共计<span className={s.emphasis}>155,474条</span>，占正向&中性内容总条数的<span className={s.emphasis}>90.67%</span>。主要来自其它平台号和普通微博用户发布。
              </li>
            </ul>
            <div className={s.chartWrapper}>
              <div className={s.chart}>
                <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
                  <Chart isShow options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: chartColorList
                  })} />
                </TooltipDrawer>
              </div>
            </div>
          </div>
          <div contentEditable style={{lineHeight: '36px'}}>注：传播可见度指有效（包括顶流、高效）内容条数在所有正向&中性内容条数中所占比例。</div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P30);



// WEBPACK FOOTER //
// src/routes/visualChart/P30/index.js